import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: "app-yonetim-ekibimiz",
  templateUrl: "./yonetim-ekibimiz.component.html",
  styleUrls: ["./yonetim-ekibimiz.component.scss"],
})
export class YonetimEkibimizComponent implements OnInit {
  teamDatas = [
    {
      name: "Kaan Öztürk",
      title: "Kurucu | Satış & İş Geliştirme",
      image: "kaan-ozturk.png",
      desc: "Bilkent Üniversitesi’nde Endüstri Mühendisliği okuduktan sonra yüksek lisansını Boğaziçi Üniversitesi’nde Mühendislik&Teknoloji Yönetimi alanında tamamlamıştır. Continental Türkiye’de Filo Operasyonları Müdürü olarak çalıştıktan sonra 2018’den beri girişimcilik  yapmaktadır.",
    },
    {
      name: "Bengisu Atay",
      title: "Yönetici Ortak | Kurumsal İş Birlikleri",
      image: "bengisu-atay.jpeg",
      desc: "Lisans eğitimini Türkiye 2.si olarak girdiği ODTÜ Endüstri Mühendisliği Bölümü’nde tamamlamıştır. Yüksek lisansını Koç Üniversitesi ve HEC Paris’te Uluslararası İşletme alanında yapmıştır. Beyaz yaka kariyerinde Amazon, TikTok, LC Waikiki gibi global ve yerel ölçekte lider şirketlerde marka stratejisi ve iş ortaklıkları alanlarında kapsamlı sorumluluklar üstlenmiştir.",
    },
    {
      name: "Begüm Döşlüoğlu",
      title: "Yönetici Ortak | Pazar Araştırmaları",
      image: "begum-dosluoglu.jpeg",
      desc: "Marmara Üniversitesi’nde lisans eğitimini Ekonomi Bölümü’nde tamamlamıştır. Kariyerine Ipsos, Xsights vb. şirketlerde pazar araştırması ve müşteri deneyimi yönetimi odaklı posxiyonlarda görev almıştır. Sektörde birçok markaya araştırma süreçleri ile ilgili konularda danışmanlık hizmeti vermektedir.",
    },
    {
      name: "Berkay Barboros",
      title: "Yönetici Ortak | Pazarlama",
      image: "berkay-barboros.jpeg",
      desc: "Marmara Üniversitesi’nde Çalışma Ekonomisi ve Endüstriyel İlişkiler Bölümü’nü bitirdikten sonra aynı okulda Girişimcilik&İnnovasyon Ekonomisi üzerine yüksek lisansını tamamlamıştır. Dijital Pazarlama alanında Inveon, Hype, Digital House, vb. şirketlerde uzman ve yönetici olarak çalışmıştır. 2021’den bu yana girişimcilik yapmaktadır.",
    },
    {
      name: "Yunus Sarıbulut",
      title: "Yönetici Ortak | Bilgi Teknolojileri",
      image: "yunus-saribulut.png",
      desc: "Atatürk Endüstri Meslek Lisesini bitirdikten sonra direkt iş hayatına başlamıştır. Web ve mobil yazılımın bütün aşamalarında uzmanlaşmıştır. OtelZ, ZeplinCar, Biletsepeti.com gibi birçok şirkette ve projede, kilit görevlerde çalışmıştır.",
    },
    {
      name: "Mehmet Kavi",
      title: "Melek Yatırımcı | Finans & Strateji",
      image: "mehmet-kavi.png",
      desc: "Yıldız Teknik Üniversitesi’nde Elektronik&Haberleşme Mühendisliği’ni bitirmiş ve aynı bölümde yüksek lisansını tamamlamıştır. Otokod Teknoloji A.Ş’nin CEO’su olarak çalışma hayatına devam etmektedir. TRAngels bünyesinde ve bireysel olarak melek yatırımcılık da yapmaktadır.",
    },
  ];

  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    scrollToTop();

    this.metaService.set({
      title: "Yönetim Ekibimiz - Bilgesin",
      description: "Yönetim Ekibimiz",
    });
  }
}
